import { render, staticRenderFns } from "./DataOne.vue?vue&type=template&id=7370c456&scoped=true&lang=pug&"
import script from "./DataOne.vue?vue&type=script&lang=js&"
export * from "./DataOne.vue?vue&type=script&lang=js&"
import style0 from "./DataOne.vue?vue&type=style&index=0&id=7370c456&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7370c456",
  null
  
)

export default component.exports